import { observer } from 'mobx-react';
import React, { MouseEvent, useMemo } from 'react';
import { Button } from 'react-bootstrap';

export interface ICancelAndEditActions {
  formId: string;
  cancelText?: string;
  editText?: string;
  saveText?: string;
  isEditing: boolean;
  cancelClicked: (e?: MouseEvent<HTMLButtonElement> | undefined) => void;
  saveClicked: (e?: MouseEvent<HTMLButtonElement> | undefined) => void;
  editClicked: (e?: MouseEvent<HTMLButtonElement> | undefined) => void;
}

export const CancelAndEditActions = observer((props: ICancelAndEditActions) => {
  const saveText = useMemo(
    () => (props.saveText ? props.saveText : 'Save'),
    [props.saveText],
  );
  const editText = useMemo(
    () => (props.editText ? props.editText : 'Edit'),
    [props.editText],
  );
  const cancelText = useMemo(
    () => (props.cancelText ? props.cancelText : 'Cancel'),
    [props.cancelText],
  );
  return (
    <>
      {props.isEditing && (
        <>
          <Button
            variant="secondary"
            className="btn-outline-primary"
            onClick={props.cancelClicked}
            form={props.formId}
            type="button"
            tabIndex={-2}
          >
            {cancelText}
          </Button>
          &nbsp;
          <Button
            form={props.formId}
            type="submit"
            onClick={props.saveClicked}
            tabIndex={-1}
          >
            {saveText}
          </Button>
        </>
      )}
      {!props.isEditing && (
        <Button
          form={props.formId}
          type="button"
          onClick={(e) => {
            props.editClicked(e);
          }}
          tabIndex={-1}
        >
          {editText}
        </Button>
      )}
    </>
  );
});
